var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.8,6.9c2.6,1.7,4.4,3.2,5.8,6,.6,6.7.8,13-1.7,19.3q-3,2.8-13.4,6.2v23.2c3.4,1.1,6.9,2.3,10.4,3.5,4.7,4.3,5,8.4,5.3,14.6q-.2,8-3.4,11.2c-4.2,2.8-6.5,3.4-11.5,3.5q-1.6,0-3.3,0c-5-.6-7.9-2.4-11-6.3-.5-.9-1.1-1.8-1.7-2.8-.6-.9-1.1-1.8-1.7-2.7C2.7,72,1.9,61.8,1.9,50.2c0-1.4,0-2.7,0-4.1,0-12.9,2.5-26.4,11-36.6,5.3-4.9,14.3-5.2,20.9-2.5ZM17.9,16.6c-9.7,14-9.3,33.8-6.9,50,1.5,7.5,4.1,14.5,10.1,19.4q4.2.8,8.1,0,2.8-2.3,2.7-6.9c0-2.8-.1-4.3-1.6-6.8q-2.5-1.6-6.4-3.1t-6.3-5.2c-.5-4.6-.4-9.2-.4-13.8,0-1.3,0-2.5,0-3.9q0-1.8,0-3.7c0-1.1,0-2.2,0-3.4.5-3.5,1.5-5.1,3.9-7.7q2.3-1.1,4.8-1.9,2.4-.7,4.5-1.6c1.3-2.6,1.4-4.1,1.4-7,0-.8,0-1.6,0-2.5q0-2.5-2.6-4.5c-5-.8-7.2-.7-11.2,2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83,23.9c6.8,4.1,12.2,10.4,14.6,18,.9,9.1,1.3,18.1-4.6,25.5-5.6,5.9-10.7,10.1-19,10.7-1.4,0-2.8,0-4.2,0-1.4,0-2.8,0-4.2,0q-3.9-.2-7.1-.9t-6.1.7c-3.1.2-6.1.1-9.3,0q-1.2-1.2-1.3-5.5c0-3.7.6-7.1,1.3-10.7q-.6-1.7-1.2-3.5c-.7-9.2-1.4-18,4.6-25.5,9.6-10.1,22.9-14.7,36.5-8.7ZM53.1,38c-5.5,7.8-3.2,18.1-2,27.1v3.5c2.3,0,4.6,0,6.9-.1q2.4.1,5.9,1.3c6.9.6,12.7.6,18.6-3.5,4.9-4.9,7.1-9.1,7.3-16,0-6-1-10.3-5.5-14.6-6.2-5.3-10.1-5.7-18-5.6-6.2.6-9.1,3.5-13.1,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.8,42.3h23.2q1,3.9,0,5.8h-23.2q-1-3.9,0-5.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.8,52.3h18.6q1.2,4.6,0,7h-18.6q-1.2-4.6,0-7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconCopy);
export default __webpack_public_path__ + "static/media/contact-us-icon-copy.9a0fce2526e0c71fc05484630bcdd06a.svg";
export { ForwardRef as ReactComponent };